import styled, { css } from 'styled-components';

import { Link } from '@powdr/components';
import { Breakpoints } from '@powdr/constants';

export const StyledOverlayImage = styled.div`
  width: ${({ $imageWidth }) => `${$imageWidth}%`};
  ${({ $addMargin }) => ($addMargin) && 'margin: 0 0 15px;'};
  max-width: 100%;
  position: relative;
  height: auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* contain, scale-down, etc. */
  }

  ${Breakpoints.mobile(css`
    width: ${({ $imageWidthMobile }) => `${$imageWidthMobile}%`};
  `)}
`;

export const OverlayLink = styled(Link)`
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
`;
